import {
  Box,
  IconButton,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Controller } from 'react-hook-form';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { useManage } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/Manage/hooks/useManage';
import {
  fields,
  rotationTexts,
} from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative';
import { InfoIconStyled } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/Manage/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const ManageCreativesHeader = ({
  onSubmit,
  onBack,
  onCancel,
  isDisplay,
}: {
  onSubmit: () => void;
  onBack?: () => void;
  onCancel?: () => void;
  isDisplay: boolean;
}) => {
  const { control } = useManage({
    onSubmit,
  });

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      pt={1}
    >
      <Box display="flex" alignItems="center" gap={2} width="100%">
        <IconButton onClick={onBack} size="large" sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h3"
          sx={{ whiteSpace: 'nowrap' }}
          data-testid="manage-creative-screen-header"
        >
          Step 2: Manage Creative
        </Typography>
      </Box>
      {!isDisplay && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ flexShrink: 0 }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Even Rotation</Typography>
            <Tooltip title={rotationTexts.random}>
              <InfoIconStyled icon={faInfoCircle} />
            </Tooltip>
          </Stack>
          <Controller
            control={control}
            name={fields.weightingRotation.path}
            render={({ field }) => (
              <Switch
                {...field}
                checked={field.value}
                onChange={e => {
                  field.onChange(e.target.checked);
                }}
              />
            )}
          />
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Weighted Rotation</Typography>
            <Tooltip title={rotationTexts.weighted}>
              <InfoIconStyled icon={faInfoCircle} />
            </Tooltip>
          </Stack>
        </Stack>
      )}
      <IconButton onClick={onCancel} size="large" aria-label="close">
        <CloseIcon data-testid="CloseIcon" />
      </IconButton>
    </Box>
  );
};
